import { render, staticRenderFns } from "./CurrentSaleLine.vue?vue&type=template&id=22ff32f2&scoped=true"
import script from "./CurrentSaleLine.vue?vue&type=script&lang=js"
export * from "./CurrentSaleLine.vue?vue&type=script&lang=js"
import style0 from "./CurrentSaleLine.vue?vue&type=style&index=0&id=22ff32f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff32f2",
  null
  
)

export default component.exports